var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { SwitchLabel, SwitchInput, SwitchSlider } from './styles';
const Switch = (_a) => {
    var { disabled = false, value = false, onChange = () => { }, 'data-qa-anchor': dataQaAnchor = '' } = _a, props = __rest(_a, ["disabled", "value", "onChange", 'data-qa-anchor']);
    const cb = useCallback(() => {
        onChange(!value);
    }, [value, onChange]);
    return (React.createElement(SwitchLabel, Object.assign({}, props, { disabled: disabled, "data-qa-anchor": `${dataQaAnchor}-label` }),
        React.createElement(SwitchInput, { type: "checkbox", value: value, checked: value, "data-qa-anchor": `${dataQaAnchor}-switch`, onChange: cb }),
        React.createElement(SwitchSlider, { disabled: disabled })));
};
export default Switch;
//# sourceMappingURL=index.js.map